<ul class="pager">
  <li>
    @if (activePage > 0) {
      <button-icon
        style="transform:scale(-1,1)"
        icon="doublearrow"
        (click)="firstPage()">
      </button-icon>
    }
  </li>
  <li>
    @if (activePage > 0) {
      <button-icon
        style="transform:scale(-1,1)"
        icon="singlearrow-left"
        (click)="previousPage()">
      </button-icon>
      }
  </li>
  <li class="pager -excess-icon"
    [class.is-active]="lowerLimit > 0">...</li>
    @for (page of pager; track page) {
      <li>
        <button class="pager -button"
          *ngIf="page.index >= lowerLimit && page.index < upperLimit"
          [class.is-active]="page.index === activePage"
          (click)="updatePage(page.index)">{{ page.label }}</button>
      </li>
    }
  <li class="pager -excess-icon"
    [class.is-active]="upperLimit < pager.length">...</li>
  <li>
    @if ((activePage + 1) < pager.length) {
      <button-icon
        style="transform:scale(-1,1)"
        icon="singlearrow-right"
        (click)="nextPage()">
      </button-icon>
    }
  </li>
  <li>
    @if ((activePage + 1) < pager.length) {
      <button-icon
        style="transform:scale(-1,1)"
        icon="doublearrow-right"
        (click)="lastPage()">
      </button-icon>
    }
  </li>
</ul>